import React, { useContext, useEffect } from "react";
import Spinner from "../../components/UI/Spinner";
import classes from "./Manut.module.scss";
import RoundedButton from "../../components/Buttons/RoundedButton";
import { useScreenHelpers } from "../../hooks/useScreenHelpers";
import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  Slide,
  Drawer,
  Button,
  Box,
  IconButton,
  Backdrop,
  Container,
  Grid2 as Grid,
  Typography,
} from "@mui/material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ManutPage = () => {
  //const { setGameUrl } = "";
  const { isFullscreen, isTouchDevice } = useScreenHelpers();

  function importAll(r) {
    return r.keys().map(r);
  }

  const images = importAll(
    require.context("../../assets/images/manut", false, /\.(png|jpe?g|svg)$/),
  );

  let games = [
    {
      name: "Supermercado",
      url: {
        dev: "https://dev.neuron.afinandoocerebro.com.br/supermercado/index.html?next=1&language=pt_br&id_jogo=114&nivel=0&id_usu=",
        prod: "https://novo.afinandoocerebro.com.br/content/jogos/supermercado/index.html?next=1&language=pt_br&id_jogo=114&nivel=0&id_usu=",
      },
      imageUrl:
        "https://dev.neuron.afinandoocerebro.com.br/supermercado/jogo_imagem_.jpg",
    },
    {
      name: "Sorveteria",
      url: {
        dev: "https://dev.neuron.afinandoocerebro.com.br/sorveteria/index.html?next=1&language=pt_br&id_jogo=114&nivel=0&id_usu=",
        prod: "https://novo.afinandoocerebro.com.br/content/jogos/sorveteria/index.html?next=1&language=pt_br&id_jogo=114&nivel=0&id_usu=",
      },
      imageUrl:
        "https://dev.neuron.afinandoocerebro.com.br/sorveteria/jogo_imagem_.jpg",
    },
    {
      name: "Achei",
      url: {
        dev: "https://dev.neuron.afinandoocerebro.com.br/achei/index.html?next=1&language=pt_br&id_jogo=114&nivel=0&id_usu=",
        prod: "https://novo.afinandoocerebro.com.br/content/jogos/achei/index.html?next=1&language=pt_br&id_jogo=114&nivel=0&id_usu=",
      },
      imageUrl:
        "https://dev.neuron.afinandoocerebro.com.br/achei/jogo_imagem_.jpg",
    },
    {
      name: "Elementos",
      url: {
        dev: "https://dev.neuron.afinandoocerebro.com.br/elementos/index.html?next=1&language=pt_br&id_jogo=114&nivel=0&id_usu=",
        prod: "https://novo.afinandoocerebro.com.br/content/jogos/elementos/index.html?next=1&language=pt_br&id_jogo=114&nivel=0&id_usu=",
      },
      imageUrl:
        "https://dev.neuron.afinandoocerebro.com.br/elementos/jogo_imagem_.jpg",
    },
    {
      name: "Dino Eggs Visual",
      url: {
        dev: "https://dev.neuron.afinandoocerebro.com.br/dinoeggs_visual/index.html?next=1&language=pt_br&id_jogo=114&nivel=0&id_usu=",
        prod: "https://novo.afinandoocerebro.com.br/content/jogos/dinoeggs_visual/index.html?next=1&language=pt_br&id_jogo=114&nivel=0&id_usu=",
      },
      imageUrl:
        "https://dev.neuron.afinandoocerebro.com.br/dinoeggs_visual/jogo_imagem_.jpg",
    },
    {
      name: "Restaurante",
      url: {
        dev: "https://dev.neuron.afinandoocerebro.com.br/restaurante_novo/index.html?next=1&language=pt_br&id_jogo=114&nivel=0&id_usu=",
        prod: "https://novo.afinandoocerebro.com.br/content/jogos/restaurante_novo/index.html?next=1&language=pt_br&id_jogo=114&nivel=0&id_usu=",
      },
      imageUrl:
        "https://dev.neuron.afinandoocerebro.com.br/restaurante_novo/jogo_imagem_.jpg",
    },
  ];

  const [open, setOpen] = React.useState(false);
  const [curUrl, setCurUrl] = React.useState(null);
  const [content, setContent] = React.useState(null);
  const [hover, setHover] = React.useState(false);

  function getGames() {
    let gameList = [];
    games.forEach((item, index) => {
      gameList.push(
        <div className="col-12 col-sm-4 text-center ">
          <div className={classes.Card}>
            <figure className={classes.ActivityImage}>
              <img className={classes.Img} src={item.imageUrl} alt="" />
            </figure>
            <ul className={classes.InfosArea}>
              <li>
                <h1 className={classes.NameTitle}>{item.name}</h1>
              </li>

              <li className={classes.BtnsArea}>
                <RoundedButton
                  text="Jogar"
                  disable={false}
                  onClick={() => {
                    OpenGame(item);
                    //   h.openActivityAsPopUp(item.url, {sub:"xxxx"}, true, item.name, 0)
                    // );
                  }}
                  title={item.name}
                />
              </li>
            </ul>
          </div>
        </div>,
      );
    });
    return gameList;
  }
  function lock(orientation) {
    let de = document.getElementById("openGameFrame");
    if (isTouchDevice) {
      try {
        if (de.requestFullscreen) de.requestFullscreen();
        else if (de.mozRequestFullScreen) de.mozRequestFullScreen();
        else if (de.webkitRequestFullscreen) de.webkitRequestFullscreen();
        else if (de.msRequestFullscreen) de.msRequestFullscreen();
        console.log("Fullscreen ativado");
        window.screen.orientation.lock(orientation);
      } catch (error) {
        console.log("Erro ao tentar fullscreen:", error);
      }
    }
  }

  const OpenGame = (item) => {
    const url =
      process.env.REACT_APP_ENV === "production" ? item.url.prod : item.url.dev;
    setCurUrl(url);
    setOpen(true);
  };

  useEffect(() => {
    if (curUrl) {
      console.log("Current URL:", curUrl);
      setContent(
        <iframe
          id="openGameFrame"
          referrerPolicy="no-referrer-when-downgrade"
          title="openGameFrame"
          onLoad={() => lock("landscape")}
          allow="autoplay *; fullscreen *;  camera *; microphone *;"
          src={curUrl}
          width="100%"
          height="100%"
          style={{ pointerEvents: "all" }}
        ></iframe>,
      );
    }
  }, [curUrl]);
  // console.log(images);
  const _loading = (
    <div>
      <Spinner />
    </div>
  );

  return (
    <>
      <Container maxWidth="lg">
        {/* <div className={classes.grid}>
          <div className={classes.wrapper2}>
            <div className={classes.box1}>
              <h1 className={classes.title + " "}>
                Site fechado para manutenção.
              </h1>
            </div>
            <div className={classes.box2}>
              <p className={classes.textInfo + " "}>
                Estamos realizando uma manutenção programada e voltaremos em
                breve. <br />
                Contamos com a sua compreensão.{" "}
              </p>
            </div>

            <div className={classes.box3}>
              <div className={classes.wrapper}>
                <img className={classes.manutLogo} src={images[0]} alt="" />
              </div>
            </div>
          </div>
        </div> */}
        <Grid container justifyContent="center">
          <Grid item size={{ xs: 12, md: 12 }} sx={{ mt: 6 }}>
            <Box
              sx={{
                borderRadius: 2,
                backgroundColor: "#fafafa",
                boxShadow: 3,
                p: { xs: 3, md: 6 },
                textAlign: "center",
              }}
            >
              <Typography variant="h4" fontWeight="bold" gutterBottom>
                Site fechado para manutenção.
              </Typography>

              <Typography variant="body1" sx={{ mb: 4 }}>
                Estamos realizando uma manutenção programada e voltaremos em
                breve.
                <br />
                Contamos com a sua compreensão.
              </Typography>

              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <Box
                  component="img"
                  src={images[0]}
                  alt=""
                  sx={{
                    maxWidth: "100%",
                    height: "auto",
                    maxHeight: 300,
                  }}
                />
              </Box>
            </Box>
          </Grid>
        </Grid>

        <div className={classes.cardsContainer + " row"}>
          <div className="col-12">
            <h1 className={classes.Playtitle + " "}>
              <img className={classes.controller} src={images[1]} alt="" />
              Playground
            </h1>
            <p className={classes.hearth}>
              <img src={images[2]} alt="" />
            </p>
            <p className={classes.playMessage}>
              Já que você veio até aqui, por que não fica e aproveita alguns
              jogos ?
            </p>
            <p className={classes.playMessage}>
              Separamos os melhores para você.
            </p>
          </div>
          {getGames()}
          <div className="col-12">
            <p className={classes.playMessage}>
              Ahh só para lembrar, como estamos em manutenção sua pontuação{" "}
              <b>não será salva.</b>
            </p>
          </div>
        </div>
      </Container>
      <div className={classes.footerDetail + " container-fluid"}>
        <div className={classes.footer + " col-12"}>
          <img className={classes.gameLogo} src={images[3]} alt="" />
        </div>
      </div>
      <Dialog
        fullScreen
        open={open}
        onClose={() => setOpen(false)}
        slots={{
          transition: Transition,
        }}
      >
        <Backdrop
          open={hover && !isFullscreen}
          sx={{
            backgroundColor: "rgba(0, 0, 0, 0.2)",
            zIndex: 10,
            pointerEvents: "none",
          }}
        />

        <Drawer
          anchor="right"
          open={!isFullscreen}
          variant="persistent"
          slotProps={{
            paper: {
              sx: {
                zIndex: 2000,
                backgroundColor: "rgba(0, 0, 0, 1)",
                maxWidth: "35px",
                width: "35px",
                transition: "width 0.3s",
                "&:hover": { width: "200px" },
              },
            },
          }}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "end",
              gap: 2,
              p: 0.5,
            }}
          >
            <Button
              onClick={() => setOpen(false)}
              sx={{
                backgroundColor: "primary.main",
                width: "25px",
                minWidth: "25px",
                height: "25px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CloseIcon sx={{ color: "primary.contrastText" }} size="small" />
            </Button>
          </Box>
        </Drawer>

        {content && (
          <Box
            id="GameFrameContent"
            sx={{
              backgroundColor: "black",
              height: "100%",
              marginRight: "20px",
              pointerEvents: "all",
            }}
          >
            {content}
          </Box>
        )}
      </Dialog>
    </>
  );
};

export default ManutPage;
